(() => {
  const modalSelector = '.quickbuy-modal';

  const icon = (dir) => dir < 0
    ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7.5 4.5 13 10l-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setupGallery(mainImage) {
    if (!mainImage || mainImage.querySelector('.rad-qb-media-nav')) return;

    const slideshow = mainImage.querySelector('.product-slideshow');
    if (!slideshow) return;

    const slides = () => Array.from(slideshow.querySelectorAll('.slide:not(.slick-cloned)'));
    if (slides().length <= 1) return;

    let fallbackIndex = Math.max(0, slides().findIndex((el) => el.classList.contains('slide--custom-initial')));

    const nav = document.createElement('div');
    nav.className = 'rad-qb-media-nav';
    nav.innerHTML =
      '<button type="button" class="rad-qb-prev" aria-label="Previous product image">' + icon(-1) + '</button>' +
      '<button type="button" class="rad-qb-next" aria-label="Next product image">' + icon(1) + '</button>';

    const count = document.createElement('div');
    count.className = 'rad-qb-media-count';
    count.setAttribute('aria-live', 'polite');

    mainImage.appendChild(nav);
    mainImage.appendChild(count);

    const getCurrentIndex = () => {
      const current = slideshow.querySelector('.slide.slick-current:not(.slick-cloned)');
      const list = slides();
      if (current) {
        const directIndex = list.indexOf(current);
        if (directIndex >= 0) return directIndex;
        const slickIndex = parseInt(current.getAttribute('data-slick-index') || '0', 10);
        if (!Number.isNaN(slickIndex) && list.length) return ((slickIndex % list.length) + list.length) % list.length;
      }
      return Math.min(fallbackIndex, Math.max(0, list.length - 1));
    };

    const updateCounter = () => {
      const list = slides();
      if (!list.length) return;
      const idx = getCurrentIndex();
      count.textContent = (idx + 1) + ' / ' + list.length;
    };

    const activateFallback = () => {
      if (slideshow.classList.contains('slick-initialized')) return;
      const list = slides();
      if (!list.length) return;
      slideshow.classList.add('rad-qb-fallback');
      list.forEach((slide, idx) => slide.classList.toggle('rad-qb-active', idx === fallbackIndex));
      updateCounter();
    };

    const moveFallback = (dir) => {
      const list = slides();
      if (!list.length) return;
      fallbackIndex = (fallbackIndex + dir + list.length) % list.length;
      list.forEach((slide, idx) => slide.classList.toggle('rad-qb-active', idx === fallbackIndex));
      updateCounter();
    };

    const navigate = (dir) => {
      const nativeArrow = mainImage.querySelector(dir < 0 ? '.slick-prev' : '.slick-next')
        || mainImage.parentElement?.querySelector(dir < 0 ? '.slideshow-controls .slick-prev' : '.slideshow-controls .slick-next');

      if (slideshow.classList.contains('slick-initialized') && nativeArrow) {
        nativeArrow.click();
        window.setTimeout(updateCounter, 100);
        return;
      }

      if (slideshow.classList.contains('slick-initialized') && window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        window.jQuery(slideshow).slick(dir < 0 ? 'slickPrev' : 'slickNext');
        window.setTimeout(updateCounter, 100);
        return;
      }

      activateFallback();
      moveFallback(dir);
    };

    nav.querySelector('.rad-qb-prev')?.addEventListener('click', () => navigate(-1));
    nav.querySelector('.rad-qb-next')?.addEventListener('click', () => navigate(1));

    const stateObserver = new MutationObserver(() => window.requestAnimationFrame(updateCounter));
    stateObserver.observe(slideshow, {subtree:true, attributes:true, attributeFilter:['class','style']});

    window.setTimeout(() => {
      if (!slideshow.classList.contains('slick-initialized')) activateFallback();
      updateCounter();
    }, 700);

    updateCounter();
  }

  function scan() {
    document.querySelectorAll(modalSelector + ' .main-image').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, {once:true});
  } else {
    scan();
  }

  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, {childList:true, subtree:true});
})();
